import { render, staticRenderFns } from "./HeaderMenuChat.vue?vue&type=template&id=a606d09e"
import script from "./HeaderMenuChat.vue?vue&type=script&lang=js"
export * from "./HeaderMenuChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports